<template>
  <div class="flex flex_col homes">
    <!-- 上面 -->
    <div class="flex flex_ju_sb tops">
      <!-- 左边 -->
      <div class="equip-all">
        <equip-model></equip-model>
      </div>
      <!-- 右边告警信息 -->
      <div class="warn-all">
        <title-model titles="告警信息">
          <span
            v-if="warnLists.length && warnLists.length > 3"
            class="font_14 c_six cursor"
            @click="warnMore"
            >更多></span
          >
        </title-model>
        <div class="warn-lists" v-if="warnList.length">
          <div
            class="flex flex_a_c warn-li"
            v-for="(item, index) in warnList"
            :key="index"
          >
            <img
              class="icon_warn"
              src="@/assets/image/home/icon_warn.png"
              alt=""
            />
            <div class="warn-words font_14">
              <el-tooltip :content="item.content">
                <div class="warn-contents ellipsis c_45">
                  {{ item.orgName }} {{ item.content }}
                </div>
              </el-tooltip>
              <div class="warn-time">{{ item.sendTime }}</div>
            </div>
          </div>
        </div>
        <div class="warn-lists t_c" v-else>
          <img
            class="warn-empty"
            src="@/assets/image/home/img_none2.png"
            alt=""
          />
          <div class="warn-empty-txt">近30分钟内暂无告警</div>
        </div>
      </div>
    </div>
    <div class="mar"></div>
    <!-- 下面生产总览 -->
    <div class="bottoms">
      <!-- titles -->
      <title-model titles="生产总览" paddings="0 0.3rem 0 0.38rem">
        <div class="flex flex_a_c font_14 c_45 bottom-t-right">
          <img
            class="icon_types"
            src="@/assets/image/home/icon_green.png"
            alt=""
          />
          <span>正常</span>
          <img
            class="icon_types"
            src="@/assets/image/home/icon_red.png"
            alt=""
          />
          <span>设备异常</span>
        </div>
      </title-model>
      <production-modal></production-modal>
    </div>
    <!-- 告警信息抽屉 -->
    <drawer-modal ref="drawerModal"></drawer-modal>
  </div>
</template>

<script>
/**
 * @description 首页
 */
import equipModel from "./components/equip-model.vue";
import titleModel from "@/components/title-model.vue";
import DrawerModal from "./components/DrawerModal.vue";
import ProductionModal from "./components/ProductionModal.vue";
export default {
  components: { equipModel, titleModel, DrawerModal, ProductionModal },
  name: "Home",
  data() {
    return {
      // 告警信息列表
      warnLists: [],
      warnTotal: 0,
    };
  },
  computed: {
    warnList() {
      if (this.warnLists.length) {
        let newArr = [];
        let num = 30 * 60; //30分钟
        this.warnLists.forEach((item, index) => {
          let time1 = new Date(item.sendTime).getTime();
          let time2 = new Date().getTime();
          let time3 = parseInt((time2 - time1) / 1000); //相差的秒数
          // console.log(time3);
          if (time3 <= num) {
            console.log(456);
            newArr.push(item);
          }
        });
        return newArr.slice(0, 3);
        // return this.warnLists.slice(0, 3);
      } else {
        return [];
      }
    },
  },
  mounted() {
    // 获取告警信息
    this.getWarnList();
  },
  methods: {
    // 获取告警信息列表
    getWarnList() {
      let params = {
        pageNum: 1,
        pageSize: 10,
      };
      this.$http
        .getAction(this.$api.alarmData, params)
        .then((res) => {
          console.log(res);
          this.warnTotal = res.total;
          if (res.total && res.total > 0) {
            let datas = res.records || [];
            this.warnLists = datas || [];
          } else {
            this.warnLists = [];
          }
          // if (res.meta.success) {
          // 	let datas = res.data || []
          // 	this.warnLists = datas || []
          // } else {
          // 	this.warnLists = []
          // }
        })
        .catch(() => {
          this.warnLists = [];
        });
    },
    // 告警信息更多点击事件
    warnMore() {
      this.$refs.drawerModal.open();
      // let newArr = [];
      // let num = 30 * 60; //30分钟
      // this.warnLists.forEach((item, index) => {
      //   let time1 = new Date(item.sendTime).getTime();
      //   let time2 = new Date().getTime();
      //   let time3 = parseInt((time2 - time1) / 1000); //相差的秒数
      //   // console.log(time3);
      //   if (time3 <= num) {
      //     console.log(456);
      //     newArr.push(item);
      //   }
      // });
      this.$refs.drawerModal.warnTotal = this.warnLists.length;
      this.$refs.drawerModal.warnList = this.warnLists;
    },
  },
};
</script>

<style lang="scss">
.homes {
  height: 100%;
  min-height: 610px;
  .tops {
    height: 35%;
  }
  .equip-all {
    flex: 1;
  }

  // 告警信息
  .warn-all {
    // width: 6.99rem;
    width: 34.8%;
    height: 100%;
    // height: 31.05vh;
    background: #ffffff;
    border-radius: 0.13rem;
    padding: 0 0.09rem 0 0.15rem;
  }
  .mar {
    width: 100%;
    height: 1.5%;
  }
  // 下面生产总览
  .bottoms {
    // margin-top: 0.19rem;
    // margin-top: 1.2%;
    width: 100%;
    height: 63.2%;
    background: #ffffff;
    border-radius: 0.13rem;
    .bottom-t-right {
      .icon_types {
        width: 0.4rem;
        margin-left: 0.51rem;
        margin-right: 0.14rem;
      }
      span {
        margin-top: 0.06rem;
      }
    }
  }
}
// 警告列表
.warn-lists {
  width: 98%;
  padding-top: 0.03rem;
  margin-left: 0.03rem;
  .warn-li {
    width: 100%;
    // height: 0.78rem;
    background-color: #faf0f0;
    text-align: left;
    // padding: 0.17rem 0 0.16rem 0.26rem;
    padding: 1.4vh 0 1.4vh 0.26rem;
    margin-top: 0.9vh;
    letter-spacing: 0.01rem;
  }
  .warn-words {
    flex: 1;
    overflow: hidden;
  }
  .warn-contents {
    width: 96.56%;
  }
  .icon_warn {
    width: 0.33rem;
    margin-right: 0.2rem;
  }
  .warn-time {
    color: #939393;
    // margin-top: 0.13rem;
    margin-top: 1vh;
  }
  .warn-empty {
    margin-top: 3.4vh;
    width: 24%;
  }
  .warn-empty-txt {
    margin-top: 1.5vh;
    color: #797979;
    box-sizing: border-box;
    padding-right: 0.25rem;
  }
}
</style>
